import React from 'react';

import { IconButton } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';

export const ArrowUp = ({ onClick }: { onClick?: any }) => (
  <IconButton className="arrow-expand-less" onClick={onClick}>
    <ExpandMore color="primary" />
  </IconButton>
);
